import { useEffect, useState } from "react";
import { SettingsLayout } from "./settings-layout";
import Dropdown from "../common/dropdown";
import { useTranslation } from "react-i18next";
import "../../i18n"; // Your i18n config file

export function ProfileSettingsPage() {
    const [isSaving, setIsSaving] = useState(false);
    const { t, i18n } = useTranslation();

    const saveSettings = async () => {

    };

    const languages: any[] = [
        { value: 'en', label: t('settings.english') },
        { value: 'es', label: t('settings.spanish') },
    ];

    const [language, setLanguage] = useState();

    const handleLanguageChange = (lang: any) => {
        setLanguage(lang);
        i18n.changeLanguage(lang.value);
        window.location.reload();
    }

    useEffect(() => {
        const lang = localStorage.getItem('i18nextLng') || 'en';
        setLanguage(languages.find(l => l.value == lang));
    }, []);

    return (
        <SettingsLayout>
            <div className="py-6 px-4 sm:p-6 lg:pb-8">
                <div>
                    <h2 className="text-lg font-medium leading-6 text-gray-900">
                        {t('settings.profileSettings')}
                    </h2>
                </div>
            </div>

            <div className="divide-y divide-gray-200 pt-6">
                <div className="px-4 sm:px-6">
                    <div className="flex items-center justify-between py-4 divide-y divide-gray-200">
                        <label className="text-sm font-medium text-gray-900">{t('settings.language')}</label>

                        <Dropdown
                            options={languages}
                            selectedOption={language}
                            onChange={language => handleLanguageChange(language)}
                        />
                    </div>
                </div>
                <div className="mt-4 flex justify-end py-4 px-4 sm:px-6">
                    <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                    >
                        {t('cancel')}
                    </button>
                    <button
                        type="submit"
                        className="ml-5 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        onClick={saveSettings}
                    >
                        {isSaving ? t('saving') : t('save')}
                    </button>
                </div>
            </div>
        </SettingsLayout>
    );
}